export default {
  technologyRow1: '杰为工业软件采用现代技术，为制造商搭建一条高速数字化转型之路。',

  technologyRow2: '云原生',
  technologyRow3: '杰为平台使用容器包的微服务构建，除了拥有基于云的基础优势，如降低成本、可扩展性及对数据和数字化链的集中访问，还可以独立部署管理每一个服务。通过DevOps自动化，无需停机自动更新，公私有云或者混合云环境里均可部署。',

  technologyRow4: '实时数字化链',
  technologyRow5: '杰为实时数字化链能够随时随地向团队提供创意和信息，助力更快更优的决策。先进的分析及AI功能自动从CAD，PLM，客户体验，工业IoT设备，供应链，质量系统，BOM中攫取数据集，解锁复杂关联，降低依赖性；实时同步功能确保所有相关用户始终获取最新的准确信息；自动化影响分析则显露设计变更、供应商延误、设备故障等问题的下游影响。',

  technologyRow6: '数字孪生',
  technologyRow7: '杰为数字孪生功能可以对物理资源、物理设备和完整生产线进行实时建模与监控。基于本地云环境和实时数字化链，利用杰为平台构建的数字孪生成为一个全透明化的智能制造模型，该模型将数字流程与数字生产线引擎及数字质量相结合，模拟相关性能，自动贡献关于生产计划、执行、质量和交付的优质决策。',

  technologyRow8: '智能应用',
  technologyRow9: '杰为采用先进的MASA、DevOps和容器架构，构建了用于设计、研发、制造和质量的现代应用，直观性强，可快速灵活部署到任何硬件。通过消对硬件和数据库的依赖性，无需中断，轻松部署新的应用程序，该应用可在其他流程中重复使用，降低IT基础架构的成本。杰为的低代码或无代码开发平台赋能IT / OT团队，开发自用的应用程序去完成特定的制造过程和任务。',

  technologyRow10: '高级分析',
  technologyRow11: '使用AI、实时事件处理和图形数据库架构，杰为平台能够把握趋势，识别模式，分析数字化链中数据流的依赖性。基于以上信息，杰为平台可以有效改进运维进程、产品质量、整体设备效率、供应链优化等。直白的复杂关联性赋能更大程度的优化，如了解设计变更对质量和多个供应商的影响，能够更加轻松应对生产需求变更时的调整。',

  technologyRow12: '工业物联网',
  technologyRow13: '基于杰为平台，制造商能够从资产、设备和机器中搜集汇总数据，并将数据转换为智能操作，可立即人工执行或自动运作，以提高运行效率，降低成本。通过联接信息技术、运行技术和知识产权资产，客户能够加强自动化，尽量减少干预，以无中断方式运行，实现工业物联网价值最大化',

  technologyRow14: '边缘计算',
  technologyRow15: '工业4.0要求数百万个传感器和IIoT设备生成的数据能够进行实时处理，意味着数据处理活动与操作必须移近源头，这也是构建杰为平台的前情。杰为数字化链确保进行精确处理所需的智能可以应用于中央云存储库中，由整条价值链共享，设备应用在云上创建配置后，能够自动加载到边缘而无需停机。'
}
